import React from "react";
import "./bodyCardEvent.sass";
import Team from "./team";

export default function BodyCardEvent({
  imgL, momioL, nameL, scoreL, urlMomioL, classTeamL,
  imgR, momioR, nameR, scoreR, urlMomioR, classTeamR,
  momioM, urlMomioM, urlEvento, flagMomios, classGame
}) {

  return (
    <div className="body-card-evento">

      <Team nameTeam={nameL} imgTeam={imgL} altTeam={nameL} momioTeam={momioL} pointsTeam={scoreL} isMiddle={false} urlMomio={urlMomioL} urlEvento={urlEvento} classTeam={classTeamL} flagMomios={flagMomios} classGame={classGame}/>

      <Team nameTeam={""} imgTeam={""} altTeam={""} momioTeam={momioM} pointsTeam={""} isMiddle={true} urlMomio={urlMomioM} urlEvento={urlEvento} classTeam={""} flagMomios={flagMomios} classGame={classGame}/>

      <Team nameTeam={nameR} imgTeam={imgR} altTeam={nameR} momioTeam={momioR} pointsTeam={scoreR} isMiddle={false} urlMomio={urlMomioR} urlEvento={urlEvento} classTeam={classTeamR} flagMomios={flagMomios} classGame={classGame}/>
    
    </div>
  );
}
